interface EmptyStateProps {
  message: string;
}

export function EmptyState({ message }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="text-4xl mb-4" aria-hidden="true">
        🔍
      </div>
      <p className="text-gray-400 text-sm max-w-xs">{message}</p>
    </div>
  );
}
